// src/components/YearSelect.js
import React from "react";

const YearSelect = ({
  selectedYear,
  onChange,
  yearsCount = 3, // how many years back to show
  className = "col-sm-3", // wrapper class
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

  return (
    <div className={className}>
      <select
        className="form-select"
        value={selectedYear || ""}
        onChange={onChange}
      >
        <option value="" disabled>
          Select Year
        </option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default YearSelect;
